// extracted by css-extract-rspack-plugin
export default {"module":"module-LypTzW","selected":"selected-UIIiZB","targetGood":"targetGood-rV4QTN","targetBad":"targetBad-WNzwow","errorIndicator":"errorIndicator-JGaPIW"};